import { render, staticRenderFns } from "./InquiredAppointmentsPerDay.vue?vue&type=template&id=9dfff974&scoped=true&"
import script from "./InquiredAppointmentsPerDay.vue?vue&type=script&lang=js&"
export * from "./InquiredAppointmentsPerDay.vue?vue&type=script&lang=js&"
import style0 from "./InquiredAppointmentsPerDay.vue?vue&type=style&index=0&id=9dfff974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfff974",
  null
  
)

export default component.exports